var _feBlend, _feBlend2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3397.7593,
    y1: 3498.6121,
    x2: 1540.7953,
    y2: 1521.8446
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2840.208,2705.541c-68.552,70.661-129.889,112.197-176.851,143.554 c-458.012,305.819-981.57,217.675-1143.442,187.547c-261.159-48.607-481.614-82.897-671.023-254.021 c-430.396-388.846-409.463-1200.008-80.587-1702.487c38.995-59.58,367.372-546.337,892.064-614.925 c12.833-1.678,22.408-2.633,30.795-3.521c81.169-8.594,584.154-53.951,994.288,289.66 c58.709,49.186,153.188,137.905,240.801,273.217C3246.605,1519.323,3247.62,2285.596,2840.208,2705.541z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047766415718245956530000017415950785695922079_",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.4595,
    y1: 2151.8665,
    x2: 3017.4019,
    y2: 2151.8665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047766415718245956530000017415950785695922079_)"
    },
    d: "M2591.847,1409.778l233.616-54.385 c0,0,156.2-14.041,177.324,124.793c21.124,138.834,15.003,961.349,8.392,1130.981c-2.179,55.915-1.911,107.574,2.846,152.619 c9.91,93.834-63.303,175.793-157.644,177.426l-434.922,7.526L2591.847,1409.778z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2467.561,3015.585c0,0,46.666-654.391,378.612-1053.292c4.328-5.201,11.825-3.896,14.115,2.501 C2896.456,2065.843,3099.76,2715.67,2467.561,3015.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047060948275362140540000006325417721655201159_",
    gradientUnits: "userSpaceOnUse",
    x1: 2480.5415,
    y1: 2567.3408,
    x2: 2831.8562,
    y2: 2567.3408
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047060948275362140540000006325417721655201159_)"
    },
    d: "M2831.846,2152.191 c-2.797,38.181-8.323,75.852-14.729,113.455c-6.624,37.545-14.403,74.905-23.562,111.943 c-18.266,74.082-41.124,147.131-69.232,218.218c-14.17,35.486-29.198,70.666-46.019,105.014 c-8.154,17.292-17.252,34.131-25.974,51.138c-9.265,16.734-18.309,33.581-28.342,49.876 c-38.853,65.854-84.365,127.914-136.314,183.761c-1.549,1.664-4.155,1.759-5.82,0.21c-1.567-1.457-1.742-3.851-0.466-5.516 l0.041-0.053c46.226-59.922,87.875-122.908,123.999-189.032c9.309-16.365,17.594-33.298,26.461-49.896 c8.238-16.936,16.847-33.678,24.523-50.882c3.849-8.594,8.026-17.03,11.755-25.679l11.372-25.857 c3.729-8.646,7.229-17.394,10.855-26.084c3.668-8.675,7.093-17.449,10.475-26.242c7.023-17.481,13.544-35.163,20.127-52.821 c6.281-17.771,12.56-35.544,18.432-53.463c12.113-35.717,22.87-71.887,33.255-108.181 c10.167-36.353,19.626-72.936,28.117-109.763c8.655-36.77,16.345-73.899,22.865-111.041l0.021-0.117 c0.393-2.239,2.526-3.736,4.766-3.343C2830.548,2148.203,2831.992,2150.115,2831.846,2152.191z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2508.703,2943.952c0,0,342.19-575.585,714.478-584.604c6.606-0.16,11.625,5.908,10.263,12.374 C3217.595,2446.96,3106.755,2840.81,2508.703,2943.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M3144.365,2450.67c-22.558,23.685-45.787,46.474-69.337,69.03 c-11.894,11.135-23.791,22.272-35.806,33.278c-12.125,10.883-24.11,21.927-36.353,32.679 c-48.855,43.143-99.226,84.572-150.928,124.268c-25.655,20.11-52.231,39.001-78.454,58.355l-40.117,27.954 c-6.697,4.642-13.352,9.348-20.124,13.88l-20.475,13.363c-54.101,36.41-110.627,69.05-167.557,100.75 c-1.986,1.105-4.49,0.393-5.596-1.592c-1.09-1.957-0.412-4.419,1.508-5.547l0.108-0.063l42.011-24.643l20.999-12.316 c6.939-4.207,13.752-8.626,20.634-12.928l41.269-25.84c13.603-8.852,27.038-17.968,40.564-26.937l20.255-13.504l19.944-13.964 l39.861-27.967c26.057-19.365,52.463-38.26,77.954-58.376c25.833-19.666,51.094-40.065,76.375-60.439l37.444-31.146 l36.979-31.697c12.316-10.58,24.373-21.454,36.574-32.167c12.089-10.835,24.063-21.801,36.034-32.767 c23.833-22.021,47.516-44.335,70.272-67.337l0.057-0.058c1.598-1.615,4.202-1.629,5.818-0.031 C3145.875,2446.486,3145.905,2449.051,3144.365,2450.67z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2116.912,1421.072c0,0,425.383,23.375,708.552-65.68c0,0-188.246-12.898-188.246,421.723 c0,332.294,49.282,966.541,6.253,1086.938c-43.028,120.397-203.922,282.241-434.563,143.15 C1978.269,2868.114,2116.912,1421.072,2116.912,1421.072z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106126245448083780640000013565178518575081856_",
    gradientUnits: "userSpaceOnUse",
    x1: 2503.8081,
    y1: 1242.8999,
    x2: 1654.1923,
    y2: -523.1577
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106126245448083780640000013565178518575081856_)"
    },
    d: "M2003.819,769.473 c0,0,469.341,51.16,529.801-28.393c0,0-48.096-143.174-190.925-133.648C2199.866,616.959,2003.819,769.473,2003.819,769.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M477.361,930.554c40.926,459.948,126.892,1432.818,164.29,1906.726 c8.337,105.65,93.02,189.101,198.781,195.889c376.74,24.182,1224.595,71.101,1549.959,27.447h0 c-74.533-36.744-121.468-112.897-120.793-195.993l17.276-2126.564c0.611-75.142,75.455-129.135,145.822-102.768 c44.331,16.612,77.9,52.001,100.925,105.791c-30.72-89.518-79.031-155.013-190.925-133.648c0,0-1094.375,10.941-1625.426,43.868 C572.967,660.248,464.546,786.544,477.361,930.554z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 519.161,
    y: 655.56,
    width: 1768.542,
    height: 2390.975
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 519.161,
    y: 655.56,
    width: 1768.542,
    height: 2390.975,
    id: "SVGID_00000124878082371070239260000010105490663243962776_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000145773593030684660240000003150797683531580063_",
    filterUnits: "userSpaceOnUse",
    x: 519.161,
    y: 655.56,
    width: 1768.542,
    height: 2390.975
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 519.161,
    y: 655.56,
    width: 1768.542,
    height: 2390.975,
    id: "SVGID_00000124878082371070239260000010105490663243962776_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000145773593030684660240000003150797683531580063_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168114630581992858960000001574678313867240593_",
    gradientUnits: "userSpaceOnUse",
    x1: 2068.2991,
    y1: 1106.5225,
    x2: -196.0579,
    y2: 4004.2043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000124878082371070239260000010105490663243962776_)",
      fill: "url(#SVGID_00000168114630581992858960000001574678313867240593_)"
    },
    d: " M748.081,712.173l1470.512-56.613c-60.651,449.014-35.054,1363.396-11.911,2264.542 c1.372,53.423,32.704,101.504,81.021,124.338l0,0c0,0-980.821,11.301-1402.255-18.59 c-99.231-7.039-180.178-82.123-194.921-180.504C632.67,2459.259,494.249,1461.858,523.059,933.815 C529.656,812.894,627.07,716.832,748.081,712.173z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073690746113828046510000000040417235083220373_",
    gradientUnits: "userSpaceOnUse",
    x1: 2068.2991,
    y1: 1106.5225,
    x2: -196.0579,
    y2: 4004.2043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      fill: "url(#SVGID_00000073690746113828046510000000040417235083220373_)"
    },
    d: "M748.081,712.173 l1470.512-56.613c-60.651,449.014-35.054,1363.396-11.911,2264.542c1.372,53.423,32.704,101.504,81.021,124.338l0,0 c0,0-980.821,11.301-1402.255-18.59c-99.231-7.039-180.178-82.123-194.921-180.504 C632.67,2459.259,494.249,1461.858,523.059,933.815C529.656,812.894,627.07,716.832,748.081,712.173z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042706307977027266870000012797325173394264194_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.2858,
    y1: 1481.8649,
    x2: 963.3754,
    y2: 1481.8649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042706307977027266870000012797325173394264194_)"
    },
    d: "M728.62,1408.638l17.162,164.715 c3.146,30.192,28.01,53.48,58.344,54.644l95.899,3.679c34.587,1.327,63.35-26.354,63.35-60.967v-177.685 c0-35.667-30.463-63.728-66.009-60.806l-113.062,9.292C750.203,1344.312,725.073,1374.606,728.62,1408.638z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119118735061672942850000012188643861121066897_",
    gradientUnits: "userSpaceOnUse",
    x1: 1032.3932,
    y1: 1379.6897,
    x2: 2028.5472,
    y2: 1379.6897
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119118735061672942850000012188643861121066897_)"
    },
    d: "M1065.85,1357.868 c159.614-4.963,772.328-24.882,927.049-29.916c19.516-0.635,35.648,15.015,35.648,34.541l0,0 c0,18.587-14.701,33.845-33.275,34.534l-926.452,34.395c-17.846,0.662-33.257-12.381-35.553-30.091l-0.581-4.48 C1030.06,1376.601,1045.44,1358.502,1065.85,1357.868z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089542416807864638180000004216575593051948700_",
    gradientUnits: "userSpaceOnUse",
    x1: 1050.655,
    y1: 1539.606,
    x2: 1719.2996,
    y2: 1539.606
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089542416807864638180000004216575593051948700_)"
    },
    d: "M1055.826,1575.014L1055.826,1575.014 c2.71,4.544,7.653,7.282,12.943,7.167l636.151-13.82c7.991-0.174,14.379-6.702,14.379-14.695v-41.94 c0-8.333-6.921-14.999-15.247-14.688l-618.413,23.123C1058.096,1521.191,1041.709,1551.341,1055.826,1575.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063605258926289484950000011882665597078349742_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.2858,
    y1: 1939.009,
    x2: 963.3754,
    y2: 1939.009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063605258926289484950000011882665597078349742_)"
    },
    d: "M728.62,1865.782l17.162,164.715 c3.146,30.193,28.01,53.48,58.344,54.644l95.899,3.679c34.587,1.327,63.35-26.354,63.35-60.967v-177.685 c0-35.666-30.463-63.728-66.009-60.806l-113.062,9.292C750.203,1801.456,725.073,1831.75,728.62,1865.782z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021109753052116005140000005269455624065235903_",
    gradientUnits: "userSpaceOnUse",
    x1: 1032.3932,
    y1: 1836.8341,
    x2: 2028.5472,
    y2: 1836.8341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021109753052116005140000005269455624065235903_)"
    },
    d: "M1065.85,1815.012 c159.614-4.963,772.328-24.882,927.049-29.915c19.516-0.635,35.648,15.014,35.648,34.54v0c0,18.587-14.701,33.844-33.275,34.534 l-926.452,34.395c-17.846,0.663-33.257-12.381-35.553-30.09l-0.581-4.481C1030.06,1833.745,1045.44,1815.646,1065.85,1815.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    d: "M1055.826,2032.159L1055.826,2032.159c2.71,4.545,7.653,7.281,12.943,7.166 l636.151-13.82c7.991-0.174,14.379-6.702,14.379-14.695v-41.94c0-8.333-6.921-14.999-15.247-14.688l-618.413,23.122 C1058.096,1978.335,1041.709,2008.485,1055.826,2032.159z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025436724947680580440000017377808868721577402_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.2858,
    y1: 2396.1533,
    x2: 963.3754,
    y2: 2396.1533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025436724947680580440000017377808868721577402_)"
    },
    d: "M728.62,2322.927l17.162,164.715 c3.146,30.193,28.01,53.48,58.344,54.644l95.899,3.679c34.587,1.327,63.35-26.353,63.35-60.966v-177.686 c0-35.666-30.463-63.728-66.009-60.806l-113.062,9.292C750.203,2258.601,725.073,2288.894,728.62,2322.927z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030459350844828638950000015169202360195857795_",
    gradientUnits: "userSpaceOnUse",
    x1: 1032.3932,
    y1: 2293.9783,
    x2: 2028.5472,
    y2: 2293.9783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030459350844828638950000015169202360195857795_)"
    },
    d: "M1065.85,2272.156 c159.614-4.963,772.328-24.882,927.049-29.915c19.516-0.635,35.648,15.014,35.648,34.541l0,0 c0,18.587-14.701,33.844-33.275,34.534l-926.452,34.395c-17.846,0.663-33.257-12.38-35.553-30.09l-0.581-4.481 C1030.06,2290.889,1045.44,2272.791,1065.85,2272.156z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132807844531762637880000017625192122065594276_",
    gradientUnits: "userSpaceOnUse",
    x1: 1050.655,
    y1: 2453.8945,
    x2: 1719.2996,
    y2: 2453.8945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132807844531762637880000017625192122065594276_)"
    },
    d: "M1055.826,2489.303L1055.826,2489.303 c2.71,4.545,7.653,7.281,12.943,7.167l636.151-13.821c7.991-0.174,14.379-6.702,14.379-14.695v-41.94 c0-8.333-6.921-14.999-15.247-14.688l-618.413,23.123C1058.096,2435.479,1041.709,2465.629,1055.826,2489.303z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2581.967,2371.146c-3.887,0-7.081-3.118-7.155-7.025c-0.005-0.219-0.438-22.775-2.606-100.068 c-0.112-3.953,3.002-7.249,6.955-7.355c3.86-0.196,7.248,3.002,7.355,6.955c2.172,77.391,2.61,99.979,2.615,100.198 c0.074,3.953-3.072,7.22-7.025,7.295C2582.06,2371.146,2582.013,2371.146,2581.967,2371.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2576.765,2182.477c-3.855,0-7.034-3.062-7.151-6.94c-1.538-50.314-3.939-105.932-6.479-164.822 c-3.426-79.563-6.978-161.839-8.852-241.094c-4.941-209.17,29.562-289.465,59.375-319.991 c16.202-16.594,29.781-17.074,31.277-17.074c3.953,0,7.16,3.207,7.16,7.16c0,3.906-3.128,7.08-7.015,7.16 c-1.631,0.116-83.884,9.154-76.477,322.41c1.869,79.116,5.412,161.317,8.842,240.815c2.541,58.932,4.941,114.597,6.479,164.999 c0.121,3.953-2.983,7.253-6.936,7.375C2576.914,2182.477,2576.839,2182.477,2576.765,2182.477z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062151423989710883010000017227298322478813367_",
    gradientUnits: "userSpaceOnUse",
    x1: 1837.3134,
    y1: 2297.5972,
    x2: 1524.3291,
    y2: 3098.926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062151423989710883010000017227298322478813367_)"
    },
    d: "M1539.326,2953.92 c-7.258,0-14.525-3.434-22.195-10.48c-28.194-25.902-35.475-65.708-37.455-103.573c-13.013,14.561-26.322,28.741-39.484,42.765 l-7.284-6.835c15.455-16.466,31.118-33.156,46.231-50.399c-1.252-51.856,1.141-104.272,7.115-155.819 c3.665-31.605,8.942-65.054,22.644-95.564c4.367-9.729,11.615-23.675,24.084-32.392c13.006-9.098,30.061-10.086,41.48-2.416 c12.831,8.623,16.29,24.962,17.773,36.499c8.721,67.825-17.741,129.988-41.471,170.194c-17.624,29.85-38.947,57.16-61.536,83.133 c1.171,38.759,6.542,81.221,34.659,107.052c5.924,5.443,11.085,8.025,15.91,7.836c7.927-0.286,14.339-7.979,19.568-15.465 c23.772-34.051,42.264-70.969,55.189-110.121c1.509-11.784,4.803-23.337,9.813-34.122l9.384,3.284 c-2.715,11.176-5.856,22.195-9.41,33.049c-1.32,11.088-0.917,22.384,1.281,33.348c1.171,5.83,6.087,25.07,20.293,27.775 c10.597,2.003,21.642-6.012,33.842-24.553l50.003-76.006l-6.318,27.209c-2.227,9.609-5.967,32.545,7.44,38.06 c7.635,3.144,15.699-1.401,25.037-6.666c9.286-5.229,18.879-10.652,29.794-9.189l5.147,0.686l-0.881,5.115 c-0.507,2.927-4.546,28.656,8.799,31.605c6.113,1.359,11.221-2.878,18.924-9.995c6.054-5.599,12.314-11.384,20.547-13.377 l2.348,9.709c-5.71,1.382-10.763,6.054-16.115,11c-7.596,7.027-16.193,14.987-27.86,12.418 c-15.198-3.359-18.934-20.482-17.285-37.195c-5.986,0.872-12.112,4.321-18.514,7.927c-10.145,5.71-21.639,12.184-33.742,7.199 c-9.989-4.107-15.396-14.027-15.813-28.23l-23.167,35.218c-9.355,14.219-24.071,32.701-44.056,28.877 c-13.719-2.614-24.27-15.933-28.217-35.625c-0.55-2.744-0.998-5.511-1.343-8.285c-12.262,30.448-27.954,59.416-46.933,86.599 c-6.246,8.952-15.009,19.282-27.391,19.731C1539.882,2953.913,1539.602,2953.92,1539.326,2953.92z M1556.708,2543.977 c-6.565,0-13.185,2.465-18.004,5.833c-10.444,7.3-16.814,19.646-20.696,28.295c-13.143,29.271-18.261,61.816-21.831,92.625 c-5.495,47.411-7.934,95.574-7.264,143.336c19.565-23.07,37.891-47.229,53.248-73.245c22.937-38.86,48.527-98.829,40.17-163.841 c-1.967-15.273-6.237-24.641-13.442-29.482C1565.189,2545.011,1560.958,2543.977,1556.708,2543.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    d: "M1977.606,1152.057l-1171.458,34.76c-42.081,1.249-77.419-31.414-79.482-73.462 l-4.298-87.633c-2.125-43.313,31.797-79.896,75.147-81.042l1177.277-31.126c44.017-1.164,80.109,34.629,79.313,78.654 l-1.52,83.999C2051.838,1117.447,2018.836,1150.833,1977.606,1152.057z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068657563023745795070000012326465514344563604_",
    gradientUnits: "userSpaceOnUse",
    x1: -2032.577,
    y1: -10440.4424,
    x2: -1975.7598,
    y2: -10440.4424,
    gradientTransform: "matrix(-0.9813 0.1926 -0.1926 -0.9813 -2396.9971 -7779.7432)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068657563023745795070000012326465514344563604_)"
    },
    d: "M1608.603,2075.021 c0,0-39.073-25.63-44.482-19.72c-1.925,2.103-6.423,9.249-10.612,17.048c-2.955,5.503-2.045,12.279,2.298,16.769l10.073,10.413 c9.598,9.921,25.84,9.209,34.313-1.689C1604.465,2092.344,1607.868,2084.931,1608.603,2075.021z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124859145568280311470000007532768109877331121_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.3094,
    y1: 2017.9856,
    x2: 530.0306,
    y2: 2017.9856,
    gradientTransform: "matrix(1 0 0 1 1290.1023 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124859145568280311470000007532768109877331121_)"
    },
    d: "M1648.439,2026.333 c0,0-13.409-35.297-29.071-32.065c-15.662,3.233-32.796,15.265-32.796,15.265l-25.161,34.028c0,0,70.631,27.825,95.472,11.879 c0,0,72.145,12.466,163.249-2.484c-13.188-27.844-21.048-55.719-25.664-77.357 C1748.325,2001.718,1698.624,2021.228,1648.439,2026.333z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169523291766599234630000012589293183996814998_",
    gradientUnits: "userSpaceOnUse",
    x1: 2329.041,
    y1: 1149.5902,
    x2: 2171.4387,
    y2: 1460.3558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169523291766599234630000012589293183996814998_)"
    },
    d: "M2030.595,1770.311 c0,0-103.293,130.099-236.127,205.289c4.616,21.638,12.476,49.513,25.664,77.357c68.908-11.307,148.659-38.292,216.27-98.254 L2030.595,1770.311z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163039620105064261740000010154951303585218180_",
    gradientUnits: "userSpaceOnUse",
    x1: 2580.6934,
    y1: 1277.2151,
    x2: 2423.0916,
    y2: 1587.9795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163039620105064261740000010154951303585218180_)"
    },
    d: "M2159.413,2346.942 c-20.2-95.95-40.4-151.5-108.038-333.371c-21.286-57.233-40.614-115.14-31.272-175.485l10.492-67.774 c0,0,131.446-44.479,277.151-1.873c0,0,198.789,86.357,63.766,512.854C2310.652,2349.382,2239.425,2368.788,2159.413,2346.942z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013185495400330620480000015271604076017260438_",
    gradientUnits: "userSpaceOnUse",
    x1: 850.1963,
    y1: 1759.2114,
    x2: 808.7088,
    y2: 1634.7488,
    gradientTransform: "matrix(1 0 0 1 1290.1023 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013185495400330620480000015271604076017260438_)"
    },
    d: "M2052.97,1683.812l34.084,81.885 c2.153,5.172,6.807,8.857,12.328,9.804c19.651,3.371,67.18,8.635,98.394-11.89c3.719-2.446,4.666-7.501,2.122-11.154 l-62.971-90.405L2052.97,1683.812z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031192678817314590120000003443139424726913422_",
    gradientUnits: "userSpaceOnUse",
    x1: 2043.3904,
    y1: 1606.4731,
    x2: 2192.5046,
    y2: 1671.3057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031192678817314590120000003443139424726913422_)"
    },
    d: "M2088.22,1558.529 c-1.431,1.347-60.413,117.174-60.413,117.174l66.851,32.271l72.212-101.473 C2166.87,1606.501,2112.184,1535.971,2088.22,1558.529z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023973579693675700520000015208229989532806544_",
    gradientUnits: "userSpaceOnUse",
    x1: 4959.7886,
    y1: 5818.8735,
    x2: 5137.915,
    y2: 5818.8735,
    gradientTransform: "matrix(-0.6854 -0.7281 -0.7281 0.6854 9787.373 1318.7853)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023973579693675700520000015208229989532806544_)"
    },
    d: "M2136.49,1618.676l-33.342,55.579 c-0.506,0.844-1.108,1.606-1.828,2.276c-3.968,3.694-17.549,14.439-28.047-0.19c-8.948-12.469-17.343-23.805-26.339-28.479 c-5.253-2.73-11.718-0.55-14.385,4.735c-5.493,10.888-16.134,33.082-22.818,54.128c-1.675,5.275,1.047,10.938,6.176,13.016 c13.537,5.484,40.291,15.403,64.031,18.679c3.9,0.538,7.761-1.107,10.082-4.286c10.214-13.993,39.002-53.096,48.828-62.883 c9.127-9.094,25.974-5.665,33.566-3.484c2.881,0.828,5.95,0.43,8.519-1.117c7.702-4.639,21.143-16.192,8.847-35.751 c-3.057-4.863-1.498-11.341,3.301-14.497c8.6-5.657,17.931-16.274,9.04-33.469c-9-17.406-25.07-18.969-36.017-17.631 c-4.843,0.592-9.759-1.948-11.618-6.46c-0.826-2.006-2.46-3.717-5.502-4.334c-5.737-1.164-9.503-6.41-8.376-12.155 c1.93-9.85,0.477-22.645-15.251-31.292c-28.844-15.859-54.109,9.981-60.534,31.795c-6.426,21.814,25.825,37.229,46.112,39.802 c14.9,1.89,23.071,18.153,26.358,26.654C2138.484,1612.396,2138.191,1615.839,2136.49,1618.676z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049181488225092148430000001370372951140925631_",
    gradientUnits: "userSpaceOnUse",
    x1: 2034.0984,
    y1: 1627.8447,
    x2: 2183.2126,
    y2: 1692.677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049181488225092148430000001370372951140925631_)"
    },
    d: "M2124.803,1687.889 c0,0,14.347-33.757,30.765-32.379c16.418,1.378,29.339,17.733,8.992,36.119 C2139.25,1714.499,2124.803,1687.889,2124.803,1687.889z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130619502655050679570000010631132679770044858_",
    gradientUnits: "userSpaceOnUse",
    x1: 2427.2026,
    y1: 3201.5259,
    x2: 2612.5193,
    y2: 3201.5259,
    gradientTransform: "matrix(-1 0 0 1 4753.7588 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130619502655050679570000010631132679770044858_)"
    },
    d: "M2146.472,3192.563 c31.747,2.744,86.846,7.201,130.283,9.113c26.11,1.149,41.143-1.408,49.801-4.873c-0.015,0.976-0.042,1.898-0.08,2.754 c-0.206,4.57-3.92,8.228-8.537,8.485c-82.076,4.581-147.351,1.585-170.59,0.172c-4.805-0.293-7.669-5.515-5.212-9.612 C2143.367,3196.555,2144.855,3194.547,2146.472,3192.563z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103980943701471251460000009211335541203827883_",
    gradientUnits: "userSpaceOnUse",
    x1: 2773.8545,
    y1: 3028.145,
    x2: 2102.8403,
    y2: 3219.3999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103980943701471251460000009211335541203827883_)"
    },
    d: "M2276.755,3201.676 c-43.437-1.912-98.536-6.369-130.283-9.113c31.213-38.294,130.283-64.104,130.283-64.104h27.981 c19.244,27.74,22.031,54.151,21.82,68.345C2317.898,3200.268,2302.865,3202.825,2276.755,3201.676z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056420263744696022820000014541890413317599417_",
    gradientUnits: "userSpaceOnUse",
    x1: 2444.3115,
    y1: 3114.4993,
    x2: 2496.512,
    y2: 3114.4993,
    gradientTransform: "matrix(-1 0 0 1 4753.7588 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056420263744696022820000014541890413317599417_)"
    },
    d: "M2309.447,3082.779l-2.618,51.815 c-0.283,5.611-4.484,10.326-10.103,11.129c-5.591,0.8-13.078,0.902-21.018-1.741c-4.885-1.626-8.512-5.742-9.413-10.763 l-9.048-50.44H2309.447z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075880743342322142020000017475645904760083858_",
    gradientUnits: "userSpaceOnUse",
    x1: 2057.7585,
    y1: 3197.5293,
    x2: 2128.7744,
    y2: 3197.5293,
    gradientTransform: "matrix(-1 0 0 1 4753.7588 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075880743342322142020000017475645904760083858_)"
    },
    d: "M2672.875,3201.287 c13.767-1.92,19.996-9.072,22.607-16.718c0.018,0.069,0.035,0.138,0.052,0.207c2.025,8.065-2.671,16.423-12.058,20.399 c-11.347,4.805-23.752,5.624-33.385,5.227c-10.332-0.426-19.818-4.702-25.03-11.545l-0.078-0.103 C2635.356,3203.886,2649.916,3204.49,2672.875,3201.287z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047762126502795525540000014943698125738428289_",
    gradientUnits: "userSpaceOnUse",
    x1: 2399.7751,
    y1: 2989.2722,
    x2: 2817.9429,
    y2: 3261.5679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047762126502795525540000014943698125738428289_)"
    },
    d: "M2607.964,3082.446h23.075 c35.148-0.718,57.219,73.416,64.444,102.123c-2.611,7.647-8.84,14.799-22.607,16.718c-22.96,3.203-37.52,2.598-47.891-2.534 c-18.989-24.988-28.404-61.584-32.928-82.943C2586.909,3091.519,2607.964,3082.446,2607.964,3082.446z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096751438872599828780000007376860528385485738_",
    gradientUnits: "userSpaceOnUse",
    x1: 2112.4563,
    y1: 3070.9836,
    x2: 2174.8403,
    y2: 3070.9836,
    gradientTransform: "matrix(-1 0 0 1 4753.7588 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096751438872599828780000007376860528385485738_)"
    },
    d: "M2628.073,3034.354l12.813,50.962 c1.572,6.248-1.419,12.71-7.197,15.676c-7.168,3.679-17.26,7.544-26.534,6.425c-4.362-0.526-7.985-3.598-9.427-7.706 l-18.811-53.617L2628.073,3034.354z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065773697841489311860000007527947542377297804_",
    gradientUnits: "userSpaceOnUse",
    x1: -229.3423,
    y1: 3162.5823,
    x2: 722.5837,
    y2: 1846.499,
    gradientTransform: "matrix(-1 0 0 1 2420.7585 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065773697841489311860000007527947542377297804_)"
    },
    d: "M2643.357,3049.084 c-15.942,14.141-67.794,16.008-67.794,16.008c-186.78-448.291-264.65-571.701-264.65-571.701 c26.969,169.205,5.813,603.529,5.813,603.529c-30.822,13.601-70.56,0-70.56,0c-2.503-277.011-41.505-574.671-91.804-765.129 c126.241-2.837,194.848-30.357,216.769-47.695C2476.362,2453.748,2643.357,3049.084,2643.357,3049.084z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111175547781792951700000010522367899378110118_",
    gradientUnits: "userSpaceOnUse",
    x1: -29.7992,
    y1: 3626.4214,
    x2: -35.5883,
    y2: 3091.8918,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 1989.9969 -609.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111175547781792951700000010522367899378110118_)"
    },
    d: "M2122.56,2457.065l23.229,144.478 c4.051,25.193,27.387,42.668,52.835,39.564l347.67-42.407c17.008-2.074,29.906-16.276,30.247-33.329 c0.744-37.332-0.723-103.77-16.39-164.301L2122.56,2457.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2210.348,2631.415c-0.573,0-1.063-0.426-1.135-1.005c-0.078-0.628,0.371-1.2,0.995-1.275 l9.085-1.109c0.663-0.072,1.197,0.371,1.274,0.995c0.078,0.627-0.371,1.2-0.995,1.275l-9.085,1.109 C2210.439,2631.412,2210.393,2631.415,2210.348,2631.415z M2189.157,2631.015c-0.091,0-0.182-0.013-0.276-0.036 c-3.024-0.748-5.99-1.808-8.809-3.148c-0.569-0.273-0.813-0.956-0.543-1.525c0.276-0.572,0.966-0.81,1.525-0.543 c2.683,1.278,5.499,2.282,8.379,2.998c0.611,0.15,0.985,0.771,0.833,1.385 C2190.139,2630.667,2189.671,2631.015,2189.157,2631.015z M2240.623,2627.721c-0.572,0-1.063-0.426-1.135-1.008 c-0.078-0.624,0.371-1.197,0.995-1.271l9.085-1.105c0.615-0.088,1.193,0.367,1.271,0.998c0.078,0.624-0.371,1.197-0.998,1.271 l-9.078,1.106C2240.714,2627.718,2240.669,2627.721,2240.623,2627.721z M2270.896,2624.031c-0.572,0-1.063-0.426-1.135-1.005 c-0.078-0.628,0.371-1.2,0.995-1.275l9.082-1.109c0.663-0.101,1.197,0.371,1.274,0.995c0.078,0.627-0.371,1.2-0.995,1.274 l-9.082,1.109C2270.987,2624.028,2270.941,2624.031,2270.896,2624.031z M2301.168,2620.337c-0.572,0-1.063-0.426-1.135-1.005 c-0.078-0.628,0.371-1.2,0.995-1.275l9.082-1.105c0.663-0.075,1.197,0.371,1.274,0.995c0.078,0.628-0.371,1.2-0.995,1.275 l-9.082,1.105C2301.259,2620.334,2301.213,2620.337,2301.168,2620.337z M2331.44,2616.646c-0.572,0-1.063-0.426-1.135-1.005 c-0.078-0.627,0.371-1.2,0.995-1.274l9.082-1.109c0.664-0.088,1.197,0.367,1.275,0.995c0.078,0.627-0.371,1.2-0.995,1.274 l-9.082,1.109C2331.531,2616.643,2331.485,2616.646,2331.44,2616.646z M2164.097,2614.669c-0.342,0-0.68-0.153-0.904-0.445 c-1.909-2.471-3.57-5.147-4.936-7.96c-0.276-0.569-0.042-1.252,0.527-1.528c0.572-0.27,1.252-0.042,1.528,0.527 c1.301,2.673,2.878,5.216,4.689,7.563c0.387,0.501,0.296,1.219-0.205,1.603 C2164.588,2614.592,2164.341,2614.669,2164.097,2614.669z M2361.712,2612.953c-0.572,0-1.063-0.426-1.135-1.005 c-0.078-0.628,0.371-1.2,0.995-1.275l9.082-1.109c0.663-0.101,1.197,0.371,1.275,0.995c0.078,0.627-0.371,1.2-0.995,1.274 l-9.082,1.109C2361.803,2612.949,2361.758,2612.953,2361.712,2612.953z M2391.984,2609.259c-0.572,0-1.063-0.426-1.135-1.005 c-0.078-0.627,0.371-1.2,0.995-1.275l9.085-1.105c0.615-0.072,1.193,0.371,1.271,0.995c0.078,0.628-0.371,1.2-0.998,1.275 l-9.079,1.105C2392.075,2609.256,2392.03,2609.259,2391.984,2609.259z M2422.257,2605.568c-0.572,0-1.063-0.426-1.135-1.005 c-0.078-0.628,0.371-1.2,0.995-1.275l9.082-1.109c0.663-0.084,1.197,0.367,1.274,0.995c0.078,0.627-0.371,1.2-0.995,1.274 l-9.082,1.109C2422.348,2605.565,2422.302,2605.568,2422.257,2605.568z M2452.529,2601.875c-0.572,0-1.063-0.426-1.135-1.005 c-0.078-0.628,0.371-1.2,0.995-1.275l9.082-1.109c0.663-0.097,1.197,0.371,1.274,0.995c0.078,0.627-0.371,1.2-0.995,1.275 l-9.082,1.109C2452.62,2601.871,2452.574,2601.875,2452.529,2601.875z M2482.801,2598.181c-0.572,0-1.063-0.426-1.135-1.005 c-0.078-0.628,0.371-1.2,0.998-1.275l9.079-1.105c0.663-0.072,1.197,0.371,1.274,0.995c0.078,0.628-0.371,1.2-0.995,1.275 l-9.082,1.105C2482.892,2598.177,2482.846,2598.181,2482.801,2598.181z M2513.073,2594.49c-0.572,0-1.063-0.426-1.135-1.005 c-0.078-0.627,0.371-1.2,0.995-1.275l9.082-1.109c0.664-0.084,1.197,0.371,1.275,0.995c0.078,0.628-0.371,1.2-0.995,1.275 l-9.082,1.109C2513.164,2594.487,2513.119,2594.49,2513.073,2594.49z M2543.209,2590.087c-0.475,0-0.917-0.299-1.083-0.774 c-0.205-0.595,0.114-1.245,0.712-1.454c2.78-0.956,5.417-2.295,7.843-3.986c0.51-0.361,1.229-0.237,1.59,0.283 c0.364,0.517,0.237,1.229-0.283,1.59c-2.598,1.814-5.427,3.252-8.408,4.279 C2543.456,2590.068,2543.333,2590.087,2543.209,2590.087z M2154.034,2586.319c-0.553,0-1.041-0.4-1.128-0.963l-1.45-9.033 c-0.101-0.624,0.322-1.209,0.946-1.31c0.627-0.101,1.213,0.322,1.31,0.946l1.45,9.033c0.101,0.625-0.322,1.21-0.946,1.311 C2154.154,2586.313,2154.092,2586.319,2154.034,2586.319z M2563.756,2569.063c-0.114,0-0.231-0.02-0.345-0.055 c-0.602-0.188-0.936-0.833-0.745-1.434c0.885-2.8,1.372-5.719,1.44-8.675c0.016-0.624,0.527-1.119,1.145-1.119 c0.01,0,0.02,0,0.026,0c0.634,0.016,1.132,0.54,1.119,1.171c-0.078,3.173-0.598,6.308-1.551,9.313 C2564.692,2568.751,2564.24,2569.063,2563.756,2569.063z M2149.195,2556.209c-0.553,0-1.037-0.4-1.128-0.962l-1.453-9.033 c-0.101-0.625,0.322-1.21,0.946-1.311c0.647-0.114,1.206,0.325,1.31,0.946l1.453,9.033c0.101,0.624-0.322,1.209-0.946,1.31 C2149.316,2556.203,2149.254,2556.209,2149.195,2556.209z M2565.375,2538.722c-0.628,0-1.138-0.507-1.145-1.135 c-0.026-2.952-0.072-5.999-0.136-9.14c-0.013-0.631,0.491-1.154,1.122-1.167c0.683-0.111,1.151,0.491,1.167,1.122 c0.065,3.147,0.111,6.207,0.136,9.166c0.003,0.631-0.504,1.148-1.135,1.154 C2565.381,2538.722,2565.378,2538.722,2565.375,2538.722z M2144.354,2526.096c-0.553,0-1.037-0.4-1.128-0.962l-1.453-9.033 c-0.101-0.624,0.322-1.209,0.946-1.31c0.631-0.091,1.21,0.322,1.311,0.946l1.453,9.033c0.101,0.624-0.322,1.21-0.946,1.31 C2144.474,2526.09,2144.412,2526.096,2144.354,2526.096z M2564.477,2508.232c-0.605,0-1.112-0.475-1.141-1.086 c-0.153-2.995-0.325-6.035-0.524-9.121c-0.039-0.631,0.439-1.177,1.067-1.216c0.761,0.049,1.177,0.442,1.216,1.067 c0.198,3.099,0.371,6.152,0.523,9.153c0.032,0.631-0.452,1.167-1.083,1.2 C2564.516,2508.232,2564.497,2508.232,2564.477,2508.232z M2139.512,2495.987c-0.553,0-1.041-0.4-1.128-0.962l-1.45-9.033 c-0.101-0.624,0.322-1.21,0.946-1.311c0.647-0.104,1.213,0.325,1.31,0.946l1.45,9.033c0.101,0.624-0.322,1.209-0.946,1.31 C2139.632,2495.98,2139.571,2495.987,2139.512,2495.987z M2562.253,2477.807c-0.582,0-1.08-0.442-1.138-1.034 c-0.293-3.004-0.608-6.035-0.949-9.085c-0.072-0.627,0.381-1.193,1.008-1.261c0.618-0.078,1.19,0.38,1.261,1.008 c0.348,3.056,0.664,6.1,0.956,9.117c0.062,0.628-0.4,1.187-1.027,1.249C2562.325,2477.804,2562.289,2477.807,2562.253,2477.807 z M2134.674,2465.877c-0.552,0-1.037-0.4-1.128-0.962l-1.642-10.2l8.376-1.073c0.647-0.101,1.203,0.367,1.281,0.988 c0.081,0.628-0.364,1.2-0.989,1.281l-6.035,0.774l1.265,7.866c0.101,0.624-0.322,1.209-0.946,1.31 C2134.794,2465.871,2134.732,2465.877,2134.674,2465.877z M2161.6,2453.212c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.628,0.364-1.2,0.988-1.281l9.075-1.161c0.729-0.094,1.2,0.367,1.281,0.988c0.081,0.628-0.364,1.2-0.989,1.281 l-9.075,1.161C2161.694,2453.209,2161.646,2453.212,2161.6,2453.212z M2191.853,2449.343c-0.569,0-1.06-0.423-1.135-0.999 c-0.081-0.627,0.364-1.2,0.989-1.281l9.075-1.161c0.722-0.088,1.2,0.364,1.281,0.989c0.081,0.628-0.364,1.2-0.989,1.281 l-9.075,1.161C2191.947,2449.34,2191.898,2449.343,2191.853,2449.343z M2558.524,2447.542c-0.556,0-1.044-0.406-1.132-0.972 c-0.452-2.998-0.936-6.006-1.447-9.017c-0.104-0.624,0.315-1.213,0.936-1.32c0.654-0.104,1.216,0.319,1.32,0.937 c0.51,3.024,0.995,6.045,1.453,9.056c0.094,0.624-0.335,1.209-0.959,1.304 C2558.638,2447.535,2558.579,2447.542,2558.524,2447.542z M2222.102,2445.47c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.627,0.364-1.2,0.989-1.281l9.075-1.161c0.715-0.078,1.2,0.367,1.281,0.989c0.081,0.627-0.364,1.2-0.989,1.281 l-9.075,1.161C2222.197,2445.467,2222.148,2445.47,2222.102,2445.47z M2252.352,2441.601c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.627,0.364-1.2,0.989-1.281l9.075-1.161c0.712-0.072,1.2,0.367,1.281,0.989c0.081,0.627-0.364,1.2-0.989,1.281 l-9.075,1.161C2252.446,2441.598,2252.397,2441.601,2252.352,2441.601z M2282.601,2437.728c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.628,0.364-1.2,0.989-1.281l9.075-1.161c0.706-0.062,1.2,0.367,1.281,0.989c0.081,0.627-0.364,1.2-0.989,1.281 l-9.075,1.161C2282.695,2437.725,2282.647,2437.728,2282.601,2437.728z M2312.854,2433.859c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.627,0.364-1.2,0.989-1.281l9.075-1.161c0.699-0.098,1.203,0.367,1.281,0.989c0.081,0.627-0.364,1.2-0.989,1.281 l-9.075,1.161C2312.948,2433.856,2312.899,2433.859,2312.854,2433.859z M2343.103,2429.99c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.627,0.364-1.2,0.989-1.281l9.075-1.164c0.651-0.088,1.203,0.364,1.281,0.989c0.081,0.628-0.364,1.2-0.989,1.281 l-9.075,1.164C2343.201,2429.986,2343.149,2429.99,2343.103,2429.99z M2373.353,2426.117c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.628,0.364-1.2,0.988-1.281l9.075-1.161c0.689-0.081,1.203,0.367,1.281,0.988c0.081,0.628-0.364,1.2-0.989,1.281 l-9.075,1.161C2373.447,2426.114,2373.398,2426.117,2373.353,2426.117z M2403.602,2422.247c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.628,0.364-1.2,0.989-1.281l9.075-1.161c0.729-0.075,1.2,0.367,1.281,0.989c0.081,0.627-0.364,1.2-0.989,1.281 l-9.075,1.161C2403.697,2422.244,2403.648,2422.247,2403.602,2422.247z M2433.855,2418.375c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.628,0.364-1.2,0.988-1.281l9.075-1.161c0.719-0.065,1.2,0.367,1.281,0.989c0.081,0.628-0.364,1.2-0.989,1.281 l-9.075,1.161C2433.949,2418.372,2433.9,2418.375,2433.855,2418.375z M2553.003,2417.552c-0.527,0-1.001-0.364-1.119-0.901 c-0.65-2.972-1.336-5.938-2.055-8.89c-0.15-0.615,0.228-1.232,0.842-1.382c0.634-0.162,1.236,0.228,1.382,0.842 c0.719,2.972,1.411,5.95,2.068,8.942c0.133,0.615-0.257,1.226-0.875,1.362 C2553.165,2417.542,2553.084,2417.552,2553.003,2417.552z M2464.104,2414.505c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.627,0.364-1.2,0.989-1.281l9.075-1.161c0.715-0.104,1.2,0.367,1.281,0.989c0.081,0.628-0.364,1.2-0.988,1.281 l-9.075,1.161C2464.199,2414.502,2464.15,2414.505,2464.104,2414.505z M2494.354,2410.633c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.627,0.364-1.2,0.989-1.281l9.075-1.161c0.709-0.094,1.2,0.367,1.281,0.989c0.081,0.627-0.364,1.2-0.989,1.281 l-9.075,1.161C2494.448,2410.629,2494.399,2410.633,2494.354,2410.633z M2524.603,2406.763c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.627,0.364-1.2,0.989-1.281l9.075-1.161c0.706-0.088,1.2,0.371,1.281,0.989c0.081,0.627-0.364,1.2-0.989,1.281 l-9.075,1.161C2524.698,2406.76,2524.649,2406.763,2524.603,2406.763z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095335200339018608810000016472109452819539899_",
    gradientUnits: "userSpaceOnUse",
    x1: -123.865,
    y1: 2981.7615,
    x2: -126.4379,
    y2: 2919.3694,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 1989.9969 -609.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095335200339018608810000016472109452819539899_)"
    },
    d: "M2210.897,2338.719l-0.386-11.323 c0.838-2.822,3.045-5.026,5.881-5.858c10.603-3.108,37.058-9.571,51.219-1.566l3.594,12.755L2210.897,2338.719z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116925839907017907350000009107320486995907508_",
    gradientUnits: "userSpaceOnUse",
    x1: -127.1197,
    y1: 2888.0925,
    x2: -114.2567,
    y2: 3066.8879,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 1989.9969 -609.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116925839907017907350000009107320486995907508_)"
    },
    d: "M2243.329,2323.627 c-2.415,0.927-4.911,1.245-7.491,0.95c-3.121-0.356-5.602-2.791-5.999-5.893l-4.483-35.035l17.829-2.281l4.48,35.009 C2248.065,2319.492,2246.275,2322.496,2243.329,2323.627z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080184600662763217510000004197071226480149430_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.9388,
    y1: 2974.6057,
    x2: 47.3659,
    y2: 2912.2141,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 1989.9969 -609.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080184600662763217510000004197071226480149430_)"
    },
    d: "M2383.588,2316.621l-0.387-11.323 c0.838-2.822,3.046-5.027,5.882-5.858c10.602-3.108,37.057-9.571,51.218-1.566l3.595,12.755L2383.588,2316.621z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138540434135539869370000008850993389047379382_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.217,
    y1: 2875.6355,
    x2: 59.0798,
    y2: 3054.4297,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 1989.9969 -609.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138540434135539869370000008850993389047379382_)"
    },
    d: "M2416.02,2301.529 c-2.414,0.927-4.911,1.245-7.49,0.95c-3.121-0.356-5.602-2.791-5.999-5.893l-4.955-38.726l17.829-2.281l4.952,38.7 C2420.756,2297.395,2418.966,2300.399,2416.02,2301.529z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039825039991041490590000017510756383092125577_",
    gradientUnits: "userSpaceOnUse",
    x1: -25.1778,
    y1: 2788.5774,
    x2: -42.5399,
    y2: 2915.8992,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 1989.9969 -609.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039825039991041490590000017510756383092125577_)"
    },
    d: "M2224.645,2292.469l190.931-30.883 c4.353-0.704,7.658-4.332,7.86-8.717c0.283-6.137,0.059-15.242-2.514-24.38c-2.926-10.392-13.045-17.096-23.833-15.976 c-35.879,3.726-126.937,15.404-174.584,41.679c-5.039,2.779-8.396,7.819-9.032,13.517c-0.608,5.434-0.559,12.581,2.032,19.529 C2216.881,2290.929,2220.738,2293.101,2224.645,2292.469z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131330701991699045090000011939126304787449774_",
    gradientUnits: "userSpaceOnUse",
    x1: 2245.0664,
    y1: 2248.9829,
    x2: 2186.2429,
    y2: 1914.9111
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131330701991699045090000011939126304787449774_)"
    },
    d: "M2219.94,2285.135 c-1.388,0-2.64-0.953-2.969-2.361c-0.072-0.315-1.782-7.817-0.738-15.393c0.855-6.207,4.981-11.641,10.769-14.174 c10.382-4.546,30.314-12.564,47.171-15.204c1.684-0.218,3.222,0.878,3.486,2.543c0.26,1.665-0.878,3.222-2.543,3.486 c-16.781,2.627-37.526,11.198-45.668,14.762c-3.856,1.691-6.604,5.3-7.173,9.42c-0.885,6.432,0.624,13.117,0.64,13.185 c0.377,1.639-0.647,3.278-2.286,3.655C2220.398,2285.109,2220.167,2285.135,2219.94,2285.135z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003102536973659009470000018355937481980353948_",
    gradientUnits: "userSpaceOnUse",
    x1: -19.9506,
    y1: 2887.7532,
    x2: -83.6167,
    y2: 3481.9702,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 1989.9969 -609.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003102536973659009470000018355937481980353948_)"
    },
    d: "M2121.377,2345.744 c61.844-8.719,329.46-45.825,408.503-46.394c6.805-0.049,12.902,4.155,15.193,10.531c7.261,20.205,22.695,67.327,27.726,115.35 c0.684,6.535-3.39,12.645-9.668,14.685l-173.383,56.352l-63.117,8.077l-194.142-13.407 c-6.843-0.472-12.486-5.495-13.697-12.215c-4.313-23.933-13.469-80.21-11.61-117.427 C2107.577,2353.388,2113.501,2346.855,2121.377,2345.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2326.325,2489.975l-9.352-0.624c-0.631-0.046-1.105-0.589-1.063-1.219 c0.045-0.631,0.637-1.063,1.219-1.063l9.127,0.631l4.89-0.647c0.728-0.062,1.2,0.367,1.281,0.988 c0.081,0.628-0.364,1.2-0.989,1.281L2326.325,2489.975z M2295.754,2487.884c-0.026,0-0.052-0.003-0.078-0.003l-9.127-0.631 c-0.631-0.045-1.105-0.588-1.063-1.219c0.045-0.631,0.627-1.07,1.219-1.063l9.127,0.631c0.631,0.046,1.106,0.589,1.063,1.219 C2296.853,2487.422,2296.352,2487.884,2295.754,2487.884z M2352.468,2486.619c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.628,0.364-1.2,0.989-1.281l9.075-1.161c0.722-0.094,1.2,0.367,1.281,0.989c0.081,0.628-0.364,1.2-0.989,1.281 l-9.075,1.161C2352.562,2486.616,2352.513,2486.619,2352.468,2486.619z M2265.329,2485.783c-0.026,0-0.052-0.003-0.078-0.003 l-9.127-0.631c-0.631-0.046-1.105-0.589-1.063-1.219c0.045-0.631,0.618-1.076,1.219-1.063l9.127,0.631 c0.631,0.045,1.105,0.588,1.063,1.219C2266.428,2485.322,2265.927,2485.783,2265.329,2485.783z M2234.907,2483.683 c-0.026,0-0.052-0.003-0.078-0.003l-9.127-0.631c-0.631-0.046-1.105-0.589-1.063-1.219c0.046-0.631,0.605-1.083,1.219-1.063 l9.127,0.631c0.631,0.045,1.105,0.589,1.063,1.219C2236.006,2483.221,2235.505,2483.683,2234.907,2483.683z M2382.717,2482.75 c-0.569,0-1.06-0.423-1.135-0.998c-0.081-0.628,0.364-1.2,0.989-1.281l3.635-0.465l5.007-1.649 c0.602-0.182,1.249,0.137,1.444,0.735c0.195,0.602-0.137,1.249-0.735,1.444l-5.216,1.694l-3.844,0.51 C2382.812,2482.746,2382.763,2482.75,2382.717,2482.75z M2204.482,2481.582c-0.026,0-0.052-0.003-0.078-0.003l-9.127-0.631 c-0.631-0.046-1.105-0.589-1.063-1.219c0.045-0.631,0.595-1.011,1.219-1.063l9.127,0.631c0.631,0.046,1.105,0.589,1.063,1.219 C2205.581,2481.121,2205.08,2481.582,2204.482,2481.582z M2174.057,2479.482c-0.026,0-0.052-0.003-0.078-0.003l-9.127-0.631 c-0.631-0.045-1.106-0.588-1.063-1.219c0.046-0.631,0.585-1.018,1.219-1.063l9.127,0.631c0.631,0.046,1.105,0.589,1.063,1.219 C2175.156,2479.02,2174.655,2479.482,2174.057,2479.482z M2143.632,2477.381c-0.026,0-0.052-0.003-0.078-0.003l-9.127-0.631 c-0.631-0.046-1.105-0.589-1.063-1.219c0.046-0.631,0.654-1.024,1.219-1.063l9.127,0.631c0.631,0.045,1.105,0.588,1.063,1.219 C2144.731,2476.919,2144.23,2477.381,2143.632,2477.381z M2411.871,2473.99c-0.481,0-0.93-0.309-1.089-0.79 c-0.195-0.602,0.136-1.249,0.735-1.444l8.701-2.826c0.598-0.179,1.245,0.136,1.444,0.735c0.195,0.602-0.137,1.249-0.735,1.444 l-8.701,2.826C2412.108,2473.97,2411.988,2473.99,2411.871,2473.99z M2440.875,2464.563c-0.481,0-0.93-0.309-1.089-0.79 c-0.195-0.602,0.136-1.249,0.735-1.444l8.701-2.825c0.595-0.182,1.245,0.136,1.444,0.735c0.195,0.602-0.136,1.249-0.735,1.444 l-8.701,2.826C2441.113,2464.544,2440.992,2464.563,2440.875,2464.563z M2130.456,2456.227c-0.556,0-1.04-0.403-1.128-0.966 c-0.458-2.891-0.923-5.924-1.385-9.065c-0.091-0.624,0.341-1.206,0.966-1.297c0.605-0.101,1.206,0.338,1.297,0.966 c0.462,3.135,0.927,6.155,1.379,9.039c0.101,0.624-0.325,1.21-0.949,1.307 C2130.573,2456.22,2130.515,2456.227,2130.456,2456.227z M2469.879,2455.137c-0.481,0-0.93-0.309-1.089-0.79 c-0.195-0.602,0.137-1.249,0.735-1.444l8.701-2.826c0.608-0.179,1.249,0.137,1.444,0.735c0.195,0.602-0.136,1.249-0.735,1.444 l-8.701,2.825C2470.117,2455.118,2469.996,2455.137,2469.879,2455.137z M2498.883,2445.711c-0.481,0-0.93-0.309-1.089-0.79 c-0.195-0.602,0.137-1.249,0.735-1.444l8.701-2.826c0.605-0.176,1.246,0.137,1.444,0.735c0.195,0.602-0.137,1.249-0.735,1.444 l-8.701,2.825C2499.121,2445.691,2499,2445.711,2498.883,2445.711z M2527.887,2436.284c-0.481,0-0.93-0.309-1.089-0.79 c-0.195-0.602,0.137-1.249,0.735-1.444l8.701-2.826c0.602-0.182,1.245,0.136,1.444,0.735c0.195,0.602-0.137,1.249-0.735,1.444 l-8.701,2.826C2528.125,2436.265,2528.004,2436.284,2527.887,2436.284z M2556.892,2426.858c-0.485,0-0.933-0.309-1.089-0.793 c-0.137-0.426-0.01-0.871,0.286-1.167c-0.289-2.608-0.611-5.212-0.962-7.81c-0.081-0.627,0.358-1.203,0.982-1.288 c0.637-0.101,1.203,0.358,1.288,0.982c0.387,2.884,0.741,5.778,1.057,8.672l0.098,0.927l-1.307,0.423 C2557.125,2426.839,2557.009,2426.858,2556.892,2426.858z M2126.2,2426.01c-0.573,0-1.063-0.426-1.135-1.005 c-0.367-3.008-0.719-6.048-1.053-9.108c-0.068-0.628,0.387-1.193,1.015-1.262c0.67-0.036,1.193,0.393,1.261,1.014 c0.328,3.047,0.68,6.081,1.047,9.075c0.078,0.628-0.367,1.2-0.995,1.275C2126.291,2426.006,2126.246,2426.01,2126.2,2426.01z  M2552.811,2397.005c-0.54,0-1.018-0.384-1.122-0.93c-0.576-3.014-1.18-6.002-1.801-8.948c-0.13-0.618,0.263-1.226,0.881-1.356 c0.647-0.117,1.226,0.267,1.356,0.881c0.627,2.966,1.232,5.967,1.811,8.994c0.117,0.621-0.289,1.219-0.91,1.336 C2552.954,2396.999,2552.879,2397.005,2552.811,2397.005z M2123.228,2395.646c-0.595,0-1.099-0.462-1.141-1.067 c-0.215-3.089-0.394-6.152-0.53-9.166c-0.029-0.631,0.458-1.167,1.089-1.193c0.689-0.117,1.167,0.458,1.194,1.089 c0.136,2.995,0.315,6.038,0.53,9.114c0.042,0.628-0.432,1.174-1.063,1.219 C2123.28,2395.643,2123.254,2395.646,2123.228,2395.646z M2546.145,2367.237c-0.51,0-0.976-0.345-1.109-0.858 c-0.774-3.021-1.557-5.967-2.338-8.831c-0.166-0.611,0.192-1.239,0.8-1.405c0.631-0.179,1.242,0.195,1.405,0.8 c0.787,2.878,1.571,5.837,2.351,8.864c0.156,0.615-0.211,1.236-0.823,1.395 C2546.333,2367.224,2546.239,2367.237,2546.145,2367.237z M2122.513,2365.156c-0.013,0-0.029,0-0.045-0.003 c-0.631-0.023-1.122-0.556-1.096-1.187l0.084-1.951c0.052-1.08,0.855-1.967,1.912-2.12l5.635-0.79 c0.628-0.136,1.206,0.345,1.291,0.972c0.088,0.628-0.348,1.203-0.972,1.291l-5.632,0.79l-0.036,1.899 C2123.631,2364.672,2123.124,2365.156,2122.513,2365.156z M2150.32,2358.429c-0.563,0-1.053-0.416-1.132-0.989 c-0.088-0.624,0.348-1.203,0.976-1.288l9.065-1.252c0.679-0.11,1.203,0.354,1.288,0.976c0.088,0.627-0.351,1.203-0.976,1.288 l-9.065,1.252C2150.424,2358.425,2150.372,2358.429,2150.32,2358.429z M2180.544,2354.276c-0.566,0-1.053-0.416-1.132-0.989 c-0.088-0.627,0.351-1.203,0.976-1.288l9.072-1.236c0.647-0.084,1.2,0.358,1.288,0.982c0.084,0.625-0.354,1.2-0.982,1.288 l-9.065,1.229C2180.645,2354.273,2180.593,2354.276,2180.544,2354.276z M2210.78,2350.196c-0.566,0-1.057-0.42-1.135-0.992 c-0.081-0.627,0.358-1.203,0.982-1.288l9.075-1.209c0.598-0.081,1.2,0.361,1.284,0.985c0.081,0.625-0.357,1.2-0.985,1.284 l-9.069,1.209C2210.881,2350.192,2210.829,2350.196,2210.78,2350.196z M2241.02,2346.18c-0.566,0-1.057-0.419-1.135-0.995 c-0.081-0.628,0.361-1.2,0.985-1.284l9.075-1.19c0.634-0.101,1.203,0.361,1.284,0.985c0.081,0.627-0.361,1.2-0.985,1.284 l-9.075,1.19C2241.117,2346.177,2241.069,2346.18,2241.02,2346.18z M2271.276,2342.246c-0.569,0-1.06-0.423-1.135-0.998 c-0.081-0.627,0.364-1.2,0.989-1.281l9.078-1.167c0.66-0.091,1.197,0.367,1.278,0.992c0.078,0.624-0.364,1.197-0.992,1.278 l-9.072,1.167C2271.373,2342.242,2271.321,2342.246,2271.276,2342.246z M2301.727,2338.373l-0.286-2.27l9.023-1.132 c0.647-0.081,1.203,0.367,1.278,0.992c0.078,0.628-0.367,1.2-0.992,1.278L2301.727,2338.373z M2537.798,2337.895 c-0.488,0-0.94-0.315-1.092-0.803c-0.969-3.105-1.909-6.012-2.793-8.701c-0.198-0.598,0.127-1.245,0.728-1.444 c0.598-0.198,1.245,0.13,1.444,0.728c0.891,2.696,1.831,5.615,2.806,8.734c0.189,0.605-0.149,1.245-0.751,1.434 C2538.026,2337.879,2537.912,2337.895,2537.798,2337.895z M2301.529,2337.245h0.029H2301.529z M2331.798,2334.64 c-0.572,0-1.063-0.426-1.135-1.005c-0.078-0.628,0.367-1.2,0.995-1.275l9.085-1.105c0.611-0.065,1.193,0.371,1.271,0.998 c0.078,0.624-0.371,1.197-0.998,1.271l-9.078,1.105C2331.889,2334.637,2331.843,2334.64,2331.798,2334.64z M2362.073,2331.002 c-0.572,0-1.066-0.429-1.135-1.011c-0.075-0.627,0.374-1.197,1.001-1.268l9.088-1.063c0.673-0.078,1.197,0.377,1.268,1.001 c0.075,0.628-0.374,1.197-1.001,1.268l-9.088,1.063C2362.161,2330.998,2362.115,2331.002,2362.073,2331.002z M2392.375,2327.51 c-0.575,0-1.07-0.433-1.138-1.018c-0.068-0.628,0.384-1.193,1.011-1.265l9.091-1.014c0.634-0.052,1.197,0.384,1.265,1.011 c0.068,0.628-0.384,1.194-1.011,1.265l-9.092,1.015C2392.459,2327.506,2392.417,2327.51,2392.375,2327.51z M2422.692,2324.196 c-0.579,0-1.076-0.436-1.138-1.024c-0.065-0.628,0.39-1.19,1.018-1.259l9.101-0.946c0.624-0.059,1.19,0.393,1.255,1.021 c0.065,0.627-0.393,1.19-1.021,1.255l-9.095,0.946C2422.77,2324.193,2422.731,2324.196,2422.692,2324.196z M2453.039,2321.139 c-0.585,0-1.083-0.445-1.138-1.037c-0.062-0.628,0.4-1.187,1.031-1.245c3.109-0.296,6.149-0.582,9.114-0.852 c0.66-0.081,1.187,0.407,1.242,1.034c0.059,0.631-0.406,1.187-1.034,1.242c-2.965,0.27-5.999,0.556-9.108,0.852 C2453.111,2321.136,2453.075,2321.139,2453.039,2321.139z M2483.419,2318.444c-0.592,0-1.093-0.455-1.141-1.054 c-0.049-0.627,0.419-1.18,1.05-1.232c3.151-0.254,6.194-0.488,9.131-0.702c0.731,0.045,1.18,0.429,1.226,1.057 c0.045,0.631-0.429,1.18-1.057,1.226c-2.936,0.215-5.973,0.449-9.117,0.702 C2483.481,2318.441,2483.448,2318.444,2483.419,2318.444z M2513.85,2316.421c-0.608,0-1.112-0.478-1.141-1.089 c-0.032-0.631,0.455-1.167,1.086-1.197c3.268-0.156,6.328-0.276,9.16-0.364c0.013,0,0.026,0,0.036,0 c0.618,0,1.125,0.491,1.145,1.112c0.016,0.631-0.478,1.157-1.109,1.177c-2.826,0.081-5.866,0.202-9.121,0.358 C2513.886,2316.421,2513.867,2316.421,2513.85,2316.421z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067208352846395177510000013747060123856247953_",
    gradientUnits: "userSpaceOnUse",
    x1: -15.3359,
    y1: 2961.0835,
    x2: -40.4173,
    y2: 3159.8044,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 1989.9969 -609.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067208352846395177510000013747060123856247953_)"
    },
    d: "M2387.196,2523.527l-55.295,7.076 c-7.246,0.927-14.038-3.683-15.814-10.735l-13.198-52.391c-2.102-8.345,3.594-16.653,12.169-17.75l66.428-8.5 c8.402-1.075,15.914,5.252,16.237,13.677l2.065,53.816C2400.073,2516.153,2394.609,2522.579,2387.196,2523.527z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069363199911510747850000012294954859244452285_",
    gradientUnits: "userSpaceOnUse",
    x1: -69.0901,
    y1: 3116.9963,
    x2: 3.8435,
    y2: 3116.9963,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 1989.9969 -609.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069363199911510747850000012294954859244452285_)"
    },
    d: "M2379.142,2514.612l-42.086,5.385 c-5.515,0.705-10.685-2.803-12.037-8.17l-10.045-39.875c-1.599-6.352,2.735-12.675,9.263-13.51l50.559-6.47 c6.395-0.818,12.112,3.998,12.358,10.41l1.572,40.96C2388.943,2508.998,2384.784,2513.889,2379.142,2514.612z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070096289619192663220000005049164462844744363_",
    gradientUnits: "userSpaceOnUse",
    x1: 2396.0161,
    y1: 2120.72,
    x2: 2254.75,
    y2: 2392.386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070096289619192663220000005049164462844744363_)"
    },
    d: "M2346.253,2090.592 c13.044,53.894,13.388,106.617,11.404,125.814c-0.749,7.238-6.565,12.888-13.824,13.397c-8.245,0.577-19.466,1.334-29.495,1.912 c-11.023,0.635-23.258-6.331-31.439-12.154c-4.177-2.973-9.58,1.656-7.247,6.221c4.019,7.864,11,14.057,17.929,19.322 c4.168,3.167,18.023,8.793,17.056,15.031c-0.305,1.968-1.491,3.68-2.766,5.209c-7.699,9.238-19.347,14.172-30.844,17.701 c-1.442,0.443-2.965,0.915-3.981,2.03c-0.286,7.435,22.583,15.694,28.486,17.653c8.843,2.935,18.221,4.178,27.508,3.2 c23.012-2.424,44.262-18.307,56.656-37.457c33.133-51.196,50.263-113.018,56.521-160.299 C2411.397,2077.361,2364.865,2085.171,2346.253,2090.592z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132785303124630706790000012334271686300844447_",
    gradientUnits: "userSpaceOnUse",
    x1: 2680.4897,
    y1: 1327.8269,
    x2: 2522.8879,
    y2: 1638.5913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132785303124630706790000012334271686300844447_)"
    },
    d: "M2442.218,2113.04 c24.581-185.681-118.511-328.456-118.511-328.456l-85.135,99.251c64.636,80.566,95.362,154.393,109.397,212.378 C2366.581,2090.792,2411.397,2082.229,2442.218,2113.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164489445601438887650000001722211256509028541_",
    gradientUnits: "userSpaceOnUse",
    x1: 2730.9832,
    y1: 1486.4933,
    x2: 1836.2012,
    y2: 2498.4973
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164489445601438887650000001722211256509028541_)"
    },
    d: "M2345.937,2095.304 c-2.376,0-4.536-1.616-5.121-4.031c-17.3-71.479-53.768-142.242-108.382-210.318c-1.823-2.271-1.46-5.591,0.81-7.414 c2.268-1.818,5.592-1.457,7.412,0.813c55.593,69.296,92.74,141.445,110.411,214.438c0.685,2.832-1.056,5.679-3.885,6.364 C2346.766,2095.258,2346.348,2095.304,2345.937,2095.304z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155854436048285976860000009157603404693278103_",
    gradientUnits: "userSpaceOnUse",
    x1: -218.7589,
    y1: 3152.7793,
    x2: -97.1893,
    y2: 3152.7793,
    gradientTransform: "matrix(1 0 0 1 1290.1023 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155854436048285976860000009157603404693278103_)"
    },
    d: "M1192.911,3196.066 c0.014-0.905-0.046-1.823-0.278-2.746c-13.692-54.284-81.651-88.095-81.651-88.095l-26.93,2.111 c-15.484,47.846-13.494,77.189-11.007,90.259c0.069,0.367,0.181,0.715,0.278,1.069 C1095.536,3200.649,1141.259,3201.945,1192.911,3196.066z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125563627542857822800000012290771400738756487_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.5845,
    y1: 3009.3616,
    x2: -356.6896,
    y2: 3356.6365,
    gradientTransform: "matrix(1 0 0 1 1290.1023 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125563627542857822800000012290771400738756487_)"
    },
    d: "M1073.322,3198.663 c1.2,4.365,4.422,7.763,8.545,8.631c31.6,6.646,81.826,1.298,102.914-1.459c4.653-0.608,8.053-4.911,8.13-9.769 C1141.259,3201.945,1095.536,3200.649,1073.322,3198.663z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083783252458376106130000016403317666670264238_",
    gradientUnits: "userSpaceOnUse",
    x1: -184.9516,
    y1: 3014.3777,
    x2: -208.1734,
    y2: 3217.0422,
    gradientTransform: "matrix(1 0 0 1 1290.1023 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083783252458376106130000016403317666670264238_)"
    },
    d: "M1073.223,3067.225l11.406,54.906 c0.835,4.023,3.927,7.036,7.672,7.387c4.583,0.43,11.108,0.683,17.67-0.281c5.884-0.864,9.981-6.844,8.938-13.26l-7.928-48.752 H1073.223z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132055626473282696610000014163263981088962955_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.1521,
    y1: 3109.2776,
    x2: -278.1228,
    y2: 3456.5532,
    gradientTransform: "matrix(1 0 0 1 1290.1023 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132055626473282696610000014163263981088962955_)"
    },
    d: "M1309.54,3197.969 c-29.742-0.833-45.125-4.335-53.078-7.586c-0.018,2.957-0.002,5.966,0.095,9.085c0.103,3.33,2.569,5.991,5.604,5.971 l163.301-1.055c5.211-0.033,8.256-6.077,5.998-10.856C1410.048,3195.298,1355.515,3199.256,1309.54,3197.969z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015350178273848003110000006285811754451145635_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.6407,
    y1: 3155.8691,
    x2: 141.3573,
    y2: 3155.8691,
    gradientTransform: "matrix(1 0 0 1 1290.1023 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015350178273848003110000006285811754451145635_)"
    },
    d: "M1431.46,3193.529 c-0.197-0.416-0.366-0.839-0.646-1.231c-14.422-20.152-51.153-60.278-123.735-77.682l-34.819-1.098 c0,0-15.505,26.948-15.798,76.866c7.953,3.25,23.336,6.753,53.078,7.586C1355.515,3199.256,1410.048,3195.298,1431.46,3193.529 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075885182426345043980000003074008120102090171_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.5274,
    y1: 2982.9355,
    x2: 87.3052,
    y2: 3185.6033,
    gradientTransform: "matrix(0.998 -0.0629 0.0629 0.998 993.2088 65.7657)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075885182426345043980000003074008120102090171_)"
    },
    d: "M1264.252,3062.366 c0.549,2.566,7.795,41.635,10.601,56.783c0.667,3.599,3.471,6.24,6.809,6.427c5.962,0.334,15.578,0.374,23.847-1.872 c4.461-1.212,7.458-5.76,7.14-10.807l-3.896-61.797L1264.252,3062.366z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070097447631165352740000010470590227046903686_",
    gradientUnits: "userSpaceOnUse",
    x1: 1098.74,
    y1: 3246.1304,
    x2: 1270.663,
    y2: 1987.9596
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070097447631165352740000010470590227046903686_)"
    },
    d: "M1237.867,2341.007 c0,0,47.898,329.133,82.464,720.797c0.644,7.295-5.169,13.643-12.334,15.151c-10.56,2.224-26.082,4.865-38.932,4.504 c-6.86-0.192-12.594-5.279-13.748-12.044c-11.775-69.056-95.802-439.674-117.856-521.243c0,0-25.332,346.486-17.235,526.246 c0.202,4.469-3.071,8.347-7.516,8.861c-6.742,0.779-17.528,1.371-31.255-0.087c-5.211-0.553-9.414-4.492-10.159-9.679 c-8.388-58.444-56.665-406.326-54.613-656.927c0.116-14.132,16.581-130.245,16.581-130.245L1237.867,2341.007z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053534470090633998250000017334056769578782381_",
    gradientUnits: "userSpaceOnUse",
    x1: 3007.7036,
    y1: -850.519,
    x2: 2272.969,
    y2: -104.6855,
    gradientTransform: "matrix(0.991 -0.1339 0.1339 0.991 690.6002 157.8111)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053534470090633998250000017334056769578782381_)"
    },
    d: "M1026.067,2359.977 c-4.925-1.75-8.358-6.214-8.894-11.413c-6.369-61.796-37.21-444.955,157.493-602.571c0,0,11.165-29.214,102.944,42.598 c91.778,71.811,42.641,147.081,20.668,250.901c-26.589,125.629-73.242,228.32-52.601,305.63 c1.424,5.335-1.381,10.937-6.562,12.847C1167.821,2384.244,1096.802,2385.114,1026.067,2359.977z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169542148557966358020000006636153887109976477_",
    gradientUnits: "userSpaceOnUse",
    x1: 1175.5846,
    y1: 1861.944,
    x2: 1300.62,
    y2: 1580.6144
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169542148557966358020000006636153887109976477_)"
    },
    d: "M1250.614,1631.19 c-0.062,5.452-77.808,115.881-77.808,115.881s13.955,27.484,80.576,49.798l57.507-118.237L1250.614,1631.19z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017500128400665698150000008267186164452517311_",
    gradientUnits: "userSpaceOnUse",
    x1: 1134.1946,
    y1: 1421.4891,
    x2: 1311.7745,
    y2: 1692.2982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017500128400665698150000008267186164452517311_)"
    },
    d: "M1311.826,1567.912 c0,0,27.664,63.549,29.522,96.903c1.858,33.354,9.045,54.997-29.522,61.714c-38.566,6.717-71.055-12.496-88.656-45.721 c0,0-27.577-51.196-21.391-72.162C1207.965,1587.68,1311.826,1567.912,1311.826,1567.912z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163781005922743885690000002786580884188614557_",
    gradientUnits: "userSpaceOnUse",
    x1: 1150.8195,
    y1: 1468.8466,
    x2: 1284.1656,
    y2: 1625.0264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163781005922743885690000002786580884188614557_)"
    },
    d: "M1236.349,1656.92l2.195-0.968 c2.795-1.232,3.991-4.559,2.587-7.272c-5.438-10.508-16.041-34.587-2.344-40.204c17.651-7.239,87.568-21.497,102.653-46.306 c14.499-23.843,1.652-54.622-17.653-63.376c-1.292-0.586-2.815-0.121-3.478,1.134l-1.609,3.044 c-1.102,2.084-4.18,1.768-4.835-0.496l0,0c-0.629-2.174-3.52-2.595-4.719-0.676c-4.637,7.422-17.156,19.456-50.633,25.634 c-47.579,8.782-79.035,28.035-79.818,60.913c-0.05,2.088-2.272,3.25-4.056,2.162c-3.513-2.141-9.135-3.146-16.647,3.172 c-13.067,10.987-7.72,39.487,20.924,62.932c1.361,1.114,1.35,3.238-0.124,4.197c-5.193,3.38-12.934,11.423,7.124,22.146 c20.747,11.091,36.239,10.181,42.205,9.196c1.484-0.245,2.44-1.682,2.117-3.151l-6.367-28.896 c-0.361-1.636,0.884-3.185,2.559-3.185H1236.349z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078733200635838894700000013861337234988081577_",
    gradientUnits: "userSpaceOnUse",
    x1: 1087.76,
    y1: 1451.9381,
    x2: 1265.3401,
    y2: 1722.7473
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078733200635838894700000013861337234988081577_)"
    },
    d: "M1237.547,1663.018 c0,0-10.553-40.594-28.754-29.213c-18.2,11.382,9.445,45.484,24.076,47.003L1237.547,1663.018z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029739403608884871980000014119861264085074329_",
    gradientUnits: "userSpaceOnUse",
    x1: 2139.479,
    y1: 1079.9685,
    x2: 1404.7434,
    y2: 1825.803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029739403608884871980000014119861264085074329_)"
    },
    d: "M1307.134,1821.915l5.36,143.964 c15.225,5.239,29.72,9.315,43.523,12.358c8.634-27.796,27.645-61.912,43.212-87.279 C1342.034,1870.74,1307.134,1821.915,1307.134,1821.915z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053529281990748396150000004799489742082232456_",
    gradientUnits: "userSpaceOnUse",
    x1: 1696.2726,
    y1: 1807.3691,
    x2: 1356.9987,
    y2: 1976.1392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053529281990748396150000004799489742082232456_)"
    },
    d: "M1592.691,1819.466 c-78.459,84.71-141.963,89.697-193.461,71.493c-15.567,25.366-34.578,59.482-43.212,87.279 c209.522,46.193,258.861-146.424,258.861-146.424L1592.691,1819.466z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112596434287655260360000005260235649963572878_",
    gradientUnits: "userSpaceOnUse",
    x1: 1691.3059,
    y1: 1765.0409,
    x2: 1575.2563,
    y2: 1886.2482
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112596434287655260360000005260235649963572878_)"
    },
    d: "M1608.603,1810.468 c0,0,9.038-9.705,25.765-6.655c16.727,3.05,31.616,8.861,42.038,0c10.422-8.861,14.086,3.031,14.086,3.031l-31.208,23.724 L1608.603,1810.468z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001628831478305056220000010444486535582454180_",
    gradientUnits: "userSpaceOnUse",
    x1: 1697.8853,
    y1: 1805.3689,
    x2: 1358.6124,
    y2: 1974.1384
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001628831478305056220000010444486535582454180_)"
    },
    d: "M1589.937,1827.059 c0,0,6.193-25.894,24.855-22.345c18.662,3.549,61.029,26.589,71.948,22.345c10.919-4.244,24.88-14.403,32.044-10.813 l-12.617,15.686c0,0,32.435-18.712,38.019-7.215l-53.971,30.372C1690.214,1855.09,1611.252,1847.185,1589.937,1827.059z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129173351932394868580000007970475413194894525_",
    gradientUnits: "userSpaceOnUse",
    x1: 1839.663,
    y1: 2091.7253,
    x2: 855.0616,
    y2: 1913.682
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129173351932394868580000007970475413194894525_)"
    },
    d: "M1220.039,2010.334 c0,0,147.506,123.536,306.787,69.632c9.879-3.344,20.681-2.617,29.904,2.253l45.792,24.186 c19.22,10.15,43.023,3.487,54.176-15.169c6.361-10.642,11.79-22.797,12.871-34.441l-89.602-36.273l6.606-10.987 c0,0-43.748-3.706-55.198,27.647c0,0-83.327,34.659-223.852-119.907C1307.522,1917.273,1243.754,1971.495,1220.039,2010.334z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181056635862254460420000016119859075983755910_",
    gradientUnits: "userSpaceOnUse",
    x1: 1490.1113,
    y1: 1341.505,
    x2: 601.147,
    y2: 3019.5527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181056635862254460420000016119859075983755910_)"
    },
    d: "M1212.099,2009.056 c-0.486,0-0.979-0.138-1.411-0.434c-62.109-41.963-91.326-109.694-91.615-110.375c-0.543-1.287,0.057-2.766,1.339-3.309 c1.287-0.547,2.764,0.05,3.311,1.337c0.282,0.666,28.957,67.06,89.791,108.165c1.156,0.779,1.46,2.347,0.678,3.507 C1213.706,2008.666,1212.91,2009.056,1212.099,2009.056z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049916892772388294150000008731071988562994307_",
    gradientUnits: "userSpaceOnUse",
    x1: 1493.2131,
    y1: 1343.1514,
    x2: 604.249,
    y2: 3021.1987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049916892772388294150000008731071988562994307_)"
    },
    d: "M1304.611,1915.178 c-0.828,0-1.642-0.41-2.125-1.16c-0.188-0.29-19.162-29.826-55.301-94.539c-11.114-19.899-25.719-32.5-43.411-37.452 c-29.298-8.186-57.534,7.522-57.813,7.679c-1.215,0.671-2.752,0.266-3.442-0.947c-0.688-1.213-0.266-2.752,0.947-3.443 c1.218-0.69,30.261-16.94,61.623-8.162c19.056,5.316,34.704,18.726,46.505,39.857c36.049,64.55,54.951,93.982,55.138,94.273 c0.755,1.169,0.417,2.732-0.755,3.487C1305.553,1915.049,1305.08,1915.178,1304.611,1915.178z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer_support.ca3b948a2b522a5635eba851b3cdf755.svg";
export { ForwardRef as ReactComponent };